import Lottie from "lottie-web";
import { useEffect, useRef } from "react";

import lottieData from "./animated-check.json";

type AnimatedCheckProps = {
  className?: string;
} & React.ComponentPropsWithoutRef<"div">;

export const AnimatedCheck: React.FC<AnimatedCheckProps> = ({
  className,
  ...props
}: AnimatedCheckProps) => {
  const ref = useRef(null);
  useEffect(() => {
    const instance = Lottie.loadAnimation({
      container: ref.current as unknown as Element,
      renderer: "svg",
      loop: false,
      autoplay: true,
      animationData: lottieData,
    });

    return () => instance.destroy();
  }, []);

  return (
    <div id="animated-check" ref={ref} className={className} {...props}></div>
  );
};
